import request from '@/utils/request'
import { invalidateApiCache } from '@/api/common'
import { markSessionPolicyAgreed } from '@/utils/policyAgreement'

// get company policy status
export function getCompanyAgreementStatus() {
  return request({ url: 'vgetPolicyAgreementStatus', method: 'get'})
}

export function companyPolicyAgree() {
  return request({ url: 'vAgreeToCompanyPolicy', method: 'get'}).then((response) => {
    invalidateApiCache('vgetPolicyAgreementStatus')
    markSessionPolicyAgreed()
    return response
  })
}